'use client'

import { Metrics } from '~/utils/metrics/metrics'

export function ReportMetrics() {
  Metrics.report(
    'page_ready_duration_seconds',
    { page: 'root' },
    performance.now(),
  )

  return null
}
